import React from "react"
import { graphql, Link } from "gatsby"
import parse from "html-react-parser"

import * as s from "./404.module.scss"

const PageNotFound = ({ data }) => {
  const pageData = data?.wpPage?.acf404Page;

  if (!pageData) {
    // Render a very basic 404 message if data is missing
    // You might want to style this basic fallback more later
    return (
      <div className={s.pageNotFound}>
        <div style={{ padding: "20px", textAlign: "center" }}>
          <h1>Page Not Found</h1>
          <p>The page you are looking for does not exist or there was an error loading its content.</p>
          <Link to="/" style={{ textDecoration: "underline" }}>
            <span>Back Home</span>
          </Link>
        </div>
      </div>
    );
  }

  const { heroImage, headlineText, blurb } = pageData;
  const heroImageUrl = heroImage?.sourceUrl;

  return (
    <div
      className={s.pageNotFound}
      style={{
        backgroundImage: heroImageUrl ? `url(${heroImageUrl})` : undefined,
        backgroundSize: "cover",
      }}
    >
      <div style={{ background: "rgba(0, 0, 0, 0.2" }}>
        <div className={s.pageNotFound__island}>
          <h1>{parse(headlineText || "Page Not Found")}</h1>

          <p className={s.pageNotFound__island___text}>{blurb || "We couldn't find the page you were looking for."}</p>

          <Link to="/" className={s.pageNotFound__island___button}>
            <span>Back Home</span>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default PageNotFound

export const query = graphql`
  query PageNotFoundQuery {
    wpPage(slug: { eq: "pagenotfound" }) {
      acf404Page {
        blurb
        headlineText
        heroImage {
          sourceUrl
        }
      }
    }
  }
`
